export type HintTone = "default" | "attention" | "human";
export type HintPlacement = "above" | "below" | "below-right" | "left";

export type FieldHint = {
  text: string;
  tone: HintTone;
  placement?: HintPlacement;
};

/**
 * Collapsed disclosure for supporting copy — field provenance, archive disclaimers and mail
 * analysis status. The note stays in the DOM (assistive tech and tests read it) but is only
 * painted while the marker is hovered or focused, so dense rows keep their height for the facts
 * the 分诊员 actually decides on. The marker colour carries the signal that the collapsed text
 * is worth a look: amber for "needs attention", blue for "touched by a human".
 */
export function InlineHint({
  text,
  label,
  tone = "default",
  placement = "above",
}: {
  text: string;
  label: string;
  tone?: HintTone;
  placement?: HintPlacement;
}) {
  return (
    <span
      className={`triage-hint is-${placement} is-${tone}`}
      role="img"
      aria-label={`${label}：${text}`}
      tabIndex={0}
    >
      <span className="triage-hint-mark" aria-hidden="true">
        {tone === "attention" ? "!" : "i"}
      </span>
      <span className="triage-hint-bubble">{text}</span>
    </span>
  );
}
